import Vue from 'vue';
import Router from 'vue-router';
import PickUp from '@/pages/PickUp';
import Showcase from './pages/Showcase.vue';
import Checkout from './pages/Checkout';
import OrderInfo from './pages/OrderInfo';
import Address from './pages/Address';

Vue.use(Router);

export default new Router({
  routes: [
    { name: 'address', path: '/address/:from?', component: Address, props: {}, meta: {} },
    { name: 'pickup', path: '/pickup/:from?', component: PickUp, props: {}, meta: {} },
    { name: 'checkout', path: '/checkout', component: Checkout, props: {}, meta: {} },
    { name: 'order', path: '/order/:hash?', component: OrderInfo, props: {}, meta: {} },
    { name: 'showcase', path: '/showcase/:section?', component: Showcase, props: {}, meta: {} },
  ]
});
